import { convertStringToSlug } from 'graphqlHooks/helper';
import solutionsData from '/src/data/solutionsData.json';

export const useSolutionLinks = () => {
  return solutionsData.map(({ title, slug }) => ({
    text: title,
    to: `/loesung/${convertStringToSlug(slug)}/`
  }));
};
